var selected_lang = variabileLinguaFlatpickr.selected_lang;
// prendo il parametro della lingua di WPML

// console.log(selected_lang);

var $cc = jQuery.noConflict();

$cc(document).on("nfFormReady", function () {
  traduzioni = {
    // oggetto con le traduzioni in lingua
    it: {
      0: "Gennaio",
      1: "Febbraio",
      2: "Marzo",
      3: "Aprile",
      4: "Maggio",
      5: "Giugno",
      6: "Luglio",
      7: "Agosto",
      8: "Settembre",
      9: "Ottobre",
      10: "Novembre",
      11: "Dicembre",
    },
  };

  if (traduzioni[selected_lang] == undefined && selected_lang != "en") {
    // se la lingua non è settata nelle traduzioni, metto italiano di default
    selected_lang = "it";
  }

  // flatpickr is not defined
  try {
    flatpickr;

    if (selected_lang != "en" && traduzioni[selected_lang] != undefined) {
      for (var i = 0; i < flatpickr.l10ns.en.months.longhand.length; i++) {
        flatpickr.l10ns.en.months.longhand[i] = traduzioni[selected_lang][i]; // imposto le traduzioni dei mesi in base alla lingua passata da WPML
      }
    }

    var arrivo = $cc(".arrivo input.flatpickr-input"); // l'elemento input arrivo
    var partenza = $cc(".partenza input.flatpickr-input"); // l'elemento input partenza

    var config = {
      // configurazione generica del flatpickr
      altInput: true,
      altFormat: "d/m/Y",
      allowInput: false,
      dateFormat: "d/m/Y",
      disableMobile: "true",
    };

    let partenzaFP = flatpickr(partenza, config);
    var today = new Date();
    var tomorrow = new Date(today);
    var tomorrow = tomorrow.setDate(tomorrow.getDate() + 1);

    partenzaFP.set("minDate", tomorrow); // imposto la data minima di partenza a domani
    partenzaFP.setDate(tomorrow, true); // imposto la data di partenza a domani
    partenzaFP.set("onChange", function (dateTime, date) {
      //
    });

    let arrivoFP = flatpickr(arrivo, config);
    arrivoFP.set("minDate", "today"); // imposto la data di arrivo a oggi
    arrivoFP.setDate(new Date(), true); // imposto la data di arrivo a oggi
    arrivoFP.set("onChange", function (dateTime, date) {
      // al cambio di data di arrivo...
      var dataDiPartenzaMinima = new Date(
        flatpickr.parseDate(date, "d/m/Y"),
      ).fp_incr(1); // ...prendo la data come parametro "data" impostata dall'utente e aggiungo 1 giorno...

      dataDiPartenzaMinima = dataDiPartenzaMinima.setHours(0, 0, 0); // ...recupero un valore numerico della data minima di partenza (che è uguale al giorno di arrivo impostato + 1)...

      var dataDiPartenzaSelezionata = partenzaFP.selectedDates[0].setHours(
        0,
        0,
        0,
      ); // ...recupero un valore numerico della data ATTUALMENTE SELEZIONATA di partenza...

      if (dataDiPartenzaSelezionata <= dataDiPartenzaMinima) {
        // ...se la data ATTUALMENTE SELEZIONATA è precedente alla data di partenza minima, allora...
        partenzaFP.setDate(dataDiPartenzaMinima); // ...cambio la data di partenza selezionata e la metto uguale a quella minima (cioè la data di arrivo +1)
      }

      partenzaFP.set("minDate", dataDiPartenzaMinima); // ...imposto la data di partenza minimo

      partenza.trigger("change");
    });
  } catch (e) {
    e; // => ReferenceError
    console.log("flatpickr is not defined");
  }
});
